import { apiFetch } from "@/lib/api";
import type { CreatePayRuleProfileInput, PayRuleProfileSummary } from "@crewledger/shared/schemas";

export function createPayRuleProfile(input: CreatePayRuleProfileInput) {
  return apiFetch<{ data: PayRuleProfileSummary }>("/api/pay-rules/profiles", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function fetchPayRuleProfiles() {
  return apiFetch<{ data: PayRuleProfileSummary[] }>("/api/pay-rules");
}
